import EmailViewer from '@admin/components/email_viewer/email'
import Container from '@admin/components/container'

const mapResources = (props, context) => ({
  email: `/api/admin/emails/${props.code}`
})

export default Container(mapResources)(EmailViewer)
